// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function resolutionComments_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var latest_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "latest_comment"), null));
  if (latest_comment.TAG === /* Ok */0) {
    var total_comments = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_comments"), null));
    if (total_comments.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                latest_comment: latest_comment._0,
                total_comments: total_comments._0
              }
            };
    }
    var e = total_comments._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".total_comments" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = latest_comment._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".latest_comment" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function ticket_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var case_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "case_id"), null));
  if (case_id.TAG === /* Ok */0) {
    var created_at = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
    if (created_at.TAG === /* Ok */0) {
      var raised_by = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "raised_by"), null));
      if (raised_by.TAG === /* Ok */0) {
        var issues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issues"), null));
        if (issues.TAG === /* Ok */0) {
          var issue_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue_comment"), null));
          if (issue_comment.TAG === /* Ok */0) {
            var actions_taken = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions_taken"), null));
            if (actions_taken.TAG === /* Ok */0) {
              var action_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action_comment"), null));
              if (action_comment.TAG === /* Ok */0) {
                var resolution_comments = resolutionComments_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resolution_comments"), null));
                if (resolution_comments.TAG === /* Ok */0) {
                  var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                  if (status.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              case_id: case_id._0,
                              created_at: created_at._0,
                              raised_by: raised_by._0,
                              issues: issues._0,
                              issue_comment: issue_comment._0,
                              actions_taken: actions_taken._0,
                              action_comment: action_comment._0,
                              resolution_comments: resolution_comments._0,
                              status: status._0
                            }
                          };
                  }
                  var e = status._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".status" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = resolution_comments._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".resolution_comments" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = action_comment._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".action_comment" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = actions_taken._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".actions_taken" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = issue_comment._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".issue_comment" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = issues._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".issues" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = raised_by._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".raised_by" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = created_at._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".created_at" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = case_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".case_id" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function t_decode(v) {
  return Decco.listFromJson(ticket_decode, v);
}

export {
  resolutionComments_decode ,
  ticket_decode ,
  t_decode ,
  
}
/* No side effect */
